import { globalConfig } from '../config/client';

export function hasAiBuilderReferral(): boolean {
  const queryParams = new URLSearchParams(window.location.search);
  const utmCampaign = queryParams.get('utm_campaign');

  if (!utmCampaign || !globalConfig.config.aiStoreBuilderReferral) {
    return false;
  }

  return utmCampaign === globalConfig.config.aiStoreBuilderReferral;
}

export function getReferralInfo(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const queryParams = new URLSearchParams(window.location.search);

  const utmCampaign = queryParams.get('utm_campaign');
  if (utmCampaign) {
    return Array.isArray(utmCampaign) ? utmCampaign[0] : utmCampaign;
  }

  const referralInfo = queryParams.get('referralInfo');
  return Array.isArray(referralInfo) ? referralInfo[0] : referralInfo;
}
